import { ValidationRule } from 'vee-validate/dist/types/types'

export const dropdownRequired: ValidationRule = {
  validate(value, args) {
    const { defaultValue } = args as { defaultValue: string }
    return value !== defaultValue
  },
  params: ['defaultValue'],
}
